import { Box, Typography, useTheme } from "@mui/material";
import { type FC, useRef } from "react";
import { useIsDarkMode } from "web_myplann/Shared/Renderer/useIsDarkMode";
import { BAR_MYPLANN_LIGHT } from "web_myplann/Utils/constants";

type Props = {
	title: string;
};

export const StickyGroupedListLabel: FC<Props> = ({ title }) => {
	const theme = useTheme();
	const ref = useRef<HTMLDivElement>(null);
	const isDarkMode = useIsDarkMode();

	return (
		<Box
			ref={ref}
			sx={{
				padding: "8px 16px",
				position: "sticky",
				top: 0,
				background: isDarkMode ? theme.palette.grey[50] : BAR_MYPLANN_LIGHT,
				textAlign: "left",
				zIndex: 1,
			}}
		>
			<Typography
				fontSize={16}
				color={theme.palette.grey[700]}
				fontWeight={600}
			>
				{title}
			</Typography>
		</Box>
	);
};
